export const GROUP_CATEGORY_LIST_ACTION = "GROUP_CATEGORY_LIST_ACTION";
export const GROUP_CATEGORY_LIST_SUCCESS = "GROUP_CATEGORY_LIST_SUCCESS";

export const GROUP_CATEGORY_CREATE_ACTION = "GROUP_CATEGORY_CREATE_ACTION";
export const GROUP_CATEGORY_CREATE_SUCCESS = "GROUP_CATEGORY_CREATE_SUCCESS";

export const GROUP_CATEGORY_DELETE_ACTION = "GROUP_CATEGORY_DELETE_ACTION";
export const GROUP_CATEGORY_DELETE_SUCCESS = "GROUP_CATEGORY_DELETE_SUCCESS";

export const GROUP_CATEGORY_GET_DETAIL_ACTION = "GROUP_CATEGORY_GET_DETAIL_ACTION";
export const GROUP_CATEGORY_GET_DETAIL_SUCCESS = "GROUP_CATEGORY_GET_DETAIL_SUCCESS";

export const GROUP_CATEGORY_UPDATE_ACTION = "GROUP_CATEGORY_UPDATE_ACTION";
export const GROUP_CATEGORY_UPDATE_SUCCESS = "GROUP_CATEGORY_UPDATE_SUCCESS";

// export const GROUP_CATEGORY_GET_TRANSLATE_ACTION = "GROUP_CATEGORY_GET_TRANSLATE_ACTION";
// export const GROUP_CATEGORY_GET_TRANSLATE_SUCCESS = "GROUP_CATEGORY_GET_TRANSLATE_SUCCESS";

export const GROUP_CATEGORY_CREATE_TRANSLATE_ACTION = "GROUP_CATEGORY_CREATE_TRANSLATE_ACTION";
export const GROUP_CATEGORY_CREATE_TRANSLATE_SUCCESS = "GROUP_CATEGORY_CREATE_TRANSLATE_SUCCESS";

export const GROUP_CATEGORY_UPDATE_TRANSLATE_ACTION = "GROUP_CATEGORY_UPDATE_TRANSLATE_ACTION";
export const GROUP_CATEGORY_UPDATE_TRANSLATE_SUCCESS = "GROUP_CATEGORY_UPDATE_TRANSLATE_SUCCESS";

export const GROUP_CATEGORY_DELETE_TRANSLATE_ACTION = "GROUP_CATEGORY_DELETE_TRANSLATE_ACTION";
export const GROUP_CATEGORY_DELETE_TRANSLATE_SUCCESS = "GROUP_CATEGORY_DELETE_TRANSLATE_SUCCESS";

export const GROUP_CATEGORY_LIST_ALL_ACTION = "GROUP_CATEGORY_LIST_ALL_ACTION";
export const GROUP_CATEGORY_LIST_ALL_SUCCESS = "GROUP_CATEGORY_LIST_ALL_SUCCESS";

export const GROUP_CATEGORY_FAIL = "GROUP_CATEGORY_FAIL";